import React from 'react';

import StandaloneVideoModule from '../../common/StandAloneVideoModule/StandAloneVideoModule';

const VideoBlock = ({ data }) => {
  const {
    block: {
      blockFields: {
        videoBlock: [video],
      },
    },
  } = data;
  return (
    <>
      {video?.videoId && (
        <StandaloneVideoModule
          videoId={video.videoId}
          title="We're on a mission to make homeownership less stressful and more accessible."
        />
      )}
    </>
  );
};

export default VideoBlock;
